<template>
    <div class="container-fluid pt-5 pb-6 pt-lg-6 pb-lg-6">
        <div class="container">
            <div class="row justify-content-center">
                <study-list-item
                        v-if="studyProduct"
                        :study-product="studyProduct"
                />
            </div>
            <div class="row justify-content-center">
                <div class="col-12" v-if="studyProduct && studyProduct.courses">
                    <course-list-item
                            v-for="item in studyProduct.courses"
                            :key="item.idcourse"
                            :course="item"
                            :hideButton="true"
                            :hideAdd="true"
                            :hideAddSwitch="true"
                    />
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12" v-if="studyProduct && studyProduct.subscriptions">
                    <SubscriptionsList v-if="studyProduct && studyProduct.subscriptions"
                                       :subscriptions="studyProduct.subscriptions"
                                       @order="orderSubscription"
                                       @bonusCourseClick="bonusCourseClick"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import studyProductApi from "../../data/StudyProductApi";
    import StudyListItem from "./StudyListItem";
    import SubscriptionsList from "../Subscriptions/SubscriptionsList";
    import CourseListItem from "../CourseListItem";

    export default {
        name: "Study",
        components: {
            StudyListItem, SubscriptionsList, CourseListItem
        },
        props: ['id'],
        data() {
            return {
                studyProduct: null,
                loading: false,
                error: null,
            }
        },
        mounted() {
            this.loading = true
            studyProductApi.fetchStudyProduct(this.id)
                .then(response => {
                    this.studyProduct = response
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },
        methods: {
            orderSubscription(subscription) {
                this.$router.push('/subscription/order/' + subscription.idsubscription)
            },

            bonusCourseClick(subscription) {
                if (subscription.courses && subscription.courses.length > 0) {
                    this.$router.push('/course/' + subscription.courses[0].slug)

                }
            },
        }
    }
</script>

<style scoped>

</style>
